import { Reveal, SplitHeading } from "./Reveal";

const STEPS = [
  ["Pick", "Choose your PC account. Money, rank and unlocks are listed on every card."],
  ["Tell us", "Drop your email and a Discord, Snapchat or Instagram handle so we can reach you."],
  ["Pay", "Card through Stripe, crypto, Cash App, or let us contact you to arrange payment."],
  ["Play", "Once payment is confirmed, we send your account login details. Load in and go."],
];

export const HowItWorks = () => (
  <section id="how-it-works" className="relative border-t border-white/10 bg-[#0b0b11]" data-testid="how-it-works-section">
    <div className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32">
      <SplitHeading eyebrow="03 — The play" lines={["Four moves.", "That's it."]} className="text-6xl md:text-8xl" />
      <div className="mt-16 grid gap-px bg-white/10 md:grid-cols-2 lg:grid-cols-4">
        {STEPS.map(([title, text], i) => (
          <Reveal key={title} delay={i * 0.1} className="group bg-[#0b0b11] p-8 transition-colors duration-500 hover:bg-[#101018]">
            <span className="font-display text-[7rem] leading-none text-stroke transition-colors duration-500 group-hover:text-[#ff3dc8]" style={{ WebkitTextStrokeColor: "rgba(255,255,255,0.5)" }}>
              0{i + 1}
            </span>
            <h3 className="mt-6 font-display text-4xl uppercase text-white">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-300">{text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
